import styled from 'styled-components';
import ProgressAnt from 'antd/lib/progress';
import { Col as ColAnt } from 'antd/lib/grid';

import { Text as TextTypography } from 'ui/components/Typography';

import DefaultUpload from 'ui/components/Upload';

import { FormItem as DefaultFormItem } from 'ui/components/Form';

export const Progress = styled(ProgressAnt)`
  margin-bottom: 15px;
`;

export const Text = styled(TextTypography)`
  padding-left: 8px;
`;

export const TextError = styled(TextTypography)`
  height: 40px;
`;

export const Col = styled(ColAnt)`
  padding: 0 8px;
`;

export const Upload = styled(DefaultUpload)`
  .ant-upload-list-item {
    margin-top: 24px;
  }
  .ant-upload-list-item-error {
    margin-top: 0;
  }
`;
export const FormItem = styled(DefaultFormItem)`
  label {
    font-weight: 500;
  }
`;
